module.exports = __webpack_public_path__ + "static/img/activity_sdy_08-2.81efe42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_08-2.jpg
// module id = xC8D
// module chunks = 0